import { DuplicateId, DuplicateIdProps } from "@mcleod/dispatch";
import { AutogenLayoutCarrierActivity } from "./autogen/AutogenLayoutCarrierActivity";

const url = "lme/crm/CarrierActivity?mode=update&key=";

const DUPLICATE_VALIDATION_PROPS: DuplicateIdProps = {
    tableName: "market_activity",
    screenName: "Carrier Activity",
    navigateToUrl: url,
    compositeKeyValues: {
        "type_of": "A"
    }
};

export class CarrierActivity extends AutogenLayoutCarrierActivity {
    onLoad(): void | Promise<void> {
        DuplicateId.configureIdTextbox(this.textboxId, DUPLICATE_VALIDATION_PROPS);
    }
}
